import I18n from 'i18n-js';
import React from 'react';
import { get } from 'lodash';
import classNames from 'classnames';

import { IUserContext, withUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import SignupSigninModal from '@reverbdotcom/commons/src/components/signup_signin_modal';
import LocationUtil from '../../shared/location_util';
import bind from '@reverbdotcom/commons/src/bind';
import { FOLLOW_PROMPT_PARAM } from '../../shared/constants';

interface Props extends IUserContext {
  addText?: string;
  unstyled?: boolean;
  followers?: {
    count: number;
    display: string;
  };
  followParams?: any;
  modalOpen: boolean;
  outlined?: boolean;
}

interface State {
  modalOpen: boolean;
}

export class LoggedOutFollowButton extends React.Component<Props, State> {
  static defaultProps: Partial<Props> = {
    unstyled: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      modalOpen: props.modalOpen,
    };
  }

  @bind
  handleClick(evt) {
    evt.preventDefault();

    this.setState({ modalOpen: true });
  }

  @bind
  handleModalClose() {
    this.setState({ modalOpen: false });
  }

  getButtonText() {
    return (
      this.props.addText ||
      I18n.t(
        'discovery.addFollowToFeed.followThis',
        { type: I18n.t('discovery.addFollowToFeed.followType.search') },
      )
    );
  }

  showShopFollowerCount() {
    const params = this.props.followParams;
    if (!get(this.props, 'followers.count')) return;
    if (!params.shop) return;

    return (
      <p className="mtb-half size-90 opacity-90 align-center">
        <span className="weight-bold pr-half">
          {this.props.followers.display}
        </span>
        {I18n.t('discovery.addFollowToFeed.followers')}
      </p>
    );
  }

  renderLoginModal() {
    const followPromptParams = { [FOLLOW_PROMPT_PARAM]: true };
    const redirectTo = LocationUtil.currentPageWithParams(followPromptParams);

    return (
      <SignupSigninModal
        onRequestClose={this.handleModalClose}
        active={this.state.modalOpen}
        message={I18n.t('discovery.searchSignup.fullLoginMessage')}
        redirectTo={redirectTo}
        trackSource="FollowButton"
      />
    );
  }

  render() {
    const classes = classNames(
      'feed-button__follow',
      { 'feed-button__follow--styled': !this.props.unstyled && !this.props.outlined },
      { 'feed-button__follow--outlined': this.props.outlined },
    );

    return (
      <div className="feed-button">
        {/* disabling inline here so we can enable this rule globally, but this should be fixed the next time this file is touched */}
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          className={classes}
          onClick={this.handleClick}
        >
          {this.getButtonText()}
        </a>
        {this.showShopFollowerCount()}
        {this.renderLoginModal()}
      </div>
    );
  }
}

export default withUserContext(LoggedOutFollowButton);
